import {Component, Input, OnDestroy} from '@angular/core';
import {Choice, MobileAlarmEvent} from '@mri/types';
import {ConfigResourceService, GenericResourceService} from '@mri/app/resources';
import {filter, mergeMap, Subject, Subscription, tap} from 'rxjs';
import {CardComponent} from '../../@theme/components/card/card.component';
import {RenderSpeedPipe, ToDateTimeFormatPipe} from '../../pipes';
import {MatMenuModule} from '@angular/material/menu';
import {MatDividerModule} from '@angular/material/divider';
import {ChoiceTypes} from "@mri/enums";

@Component({
  selector: 'app-mobile-alarm-event-show',
  templateUrl: './mobile-alarm-event-show.component.html',
  standalone: true,
  imports: [
    CardComponent,
    RenderSpeedPipe,
    MatMenuModule,
    MatDividerModule,
    ToDateTimeFormatPipe
  ],
  styleUrl: './mobile-alarm-event-show.component.scss'
})
export class MobileAlarmEventShowComponent implements OnDestroy {
  private _subscription = new Subscription();
  private _elementId$ = new Subject<string>();
  private _element$ = new Subject<MobileAlarmEvent>();

  mobileEvent?: MobileAlarmEvent;
  choice?: Choice;
  sensors: { value: string, type: string, key: string }[] = [];

  @Input() set elementId(value: string) {
    this._elementId$.next(value);
  }

  @Input() set element(value: MobileAlarmEvent) {
    this._element$.next(value);
  }

  constructor(
    private _genericRsrSrv: GenericResourceService,
    private _configSrv: ConfigResourceService
  ) {

    this._subscription.add(
      this._elementId$.pipe(
        filter(value => !!value),
        mergeMap(elementId => this._genericRsrSrv.getElement<MobileAlarmEvent>('mobiles/alarms/events', elementId)),
        tap(response => this._element$.next(response.object))
      ).subscribe()
    );

    this._subscription.add(
      this._element$.pipe(
        filter(value => !!value),
        tap(element => this.mobileEvent = element),
        tap(() => this.sensors = this.generateSensorsList()),
        tap(() => this.choice = this.getChoice())
      ).subscribe()
    );
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

  getChoice(){
    return this._configSrv.getChoices(ChoiceTypes.ALARM).find( c => c.value === this.mobileEvent?.type)
  }


  generateSensorsList() {
    if (!this.mobileEvent) return [];
    return Object.keys(this.mobileEvent?.sensors || {})
      .filter(key => key)
      .map(key => ({ key, value: this.mobileEvent?.sensors?.[key], type: typeof this.mobileEvent?.sensors?.[key] }));
  }


}
